import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";

export type ArticlesProps = {
  title: string;
  highlight: string;
  description?: string;
  titleHeight?: number;
  articles: {
    url: string;
    image: string;
    title: string;
    description: string;
  }[];
};

export default function ProductInsightsAndInspirationsSection({
  title,
  highlight,
  articles,
  description,
  titleHeight,
}: ArticlesProps) {
  const [before, after] = title.split(highlight);
  const [isMdUp, setIsMdUp] = useState(false);

  useEffect(() => {
    const checkWidth = () => setIsMdUp(window.innerWidth >= 768);
    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);
  return (
    <article className="flex flex-col gap-4 justify-center md:items-center">
      <div>
        <p className="">
          <span className="bg-[#E7D7FD] rounded-full px-3 py-1 text-[#8937F4] inline-block font-semibold">
            BLOG
          </span>
        </p>
      </div>

      <div className="flex flex-col gap-4 md:items-center md:text-center">
        <h2 className="md:text-[45px] text-2xl text-secondary-900 font-medium">
          {before}{" "}
          <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
            {highlight}
          </span>{" "}
          {after}
        </h2>
        {description ? (
          <span className="text-base md:text-xl md:w-4/5 md:text-center">
            {description}
          </span>
        ) : null}
      </div>

      <ul className="flex gap-5 lg:gap-[3.4rem] overflow-x-auto no-scrollbar  mt-8">
        {articles.map((article, i) => (
          <li key={i} className="flex-shrink-0 w-[250px] lg:w-[283px]">
            <Link
              target="_blank"
              href={article.url}
              rel="noreferrer noopener nofollow"
              className="flex flex-col gap-2 rounded lg:rounded-none overflow-hidden justify-between h-full"
            >
              <div className="flex flex-col gap-4">
                <div className="relative aspect-[370/380] lg:aspect-[283/380] w-full rounded-[1.25rem] overflow-hidden mx-auto">
                  <Image
                    priority
                    src={article.image}
                    alt={article.title}
                    fill
                    className="object-cover"
                  />
                </div>
                <aside className="flex flex-col justify-center  font-inter text-secondary-900">
                  <h3
                    className="font-bold text-xl md:text-2xl"
                    style={
                      isMdUp && titleHeight
                        ? { minHeight: `${titleHeight}px` }
                        : titleHeight && titleHeight > 70
                        ? { minHeight: `85px` }
                        : // : titleHeight && titleHeight < 60
                          // ? { minHeight: `${titleHeight}px` }
                          { minHeight: `${titleHeight}px` }
                    }
                  >
                    {article.title}
                  </h3>
                  <span className="text-xs md:text-base line-clamp-2">
                    {article.description}
                  </span>
                </aside>
              </div>
              <Link
                href={article.url}
                target="_blank"
                className="text-start text-sm text-[#A15FF6]"
              >
                Learn More...
              </Link>
            </Link>
          </li>
        ))}
      </ul>
    </article>
  );
}
